import styled, { css } from "styled-components";

interface ContainerProps {
  is_loading: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  display: none;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: all 0.3s ease-in-out;
  visibility: hidden;
  opacity: 0;
  font-size: 14px;

  ${({ is_loading }) =>
    is_loading &&
    css`
      visibility: visible;
      opacity: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

export const SpinnerWrapper = styled.div`
  position: relative;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpinnerSvg = styled.svg`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  animation: rotate 2s linear infinite;
  
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SpinnerCircle = styled.circle`
  stroke: var(--fixit);
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
`;

export const LogoImage = styled.img`
  width: 55px;
  height: auto;
  position: relative;
  z-index: 2;
  
  /* Efeito Zoom in / Zoom out moderno */
  animation: zoomInOut 1.5s ease-in-out infinite;

  @keyframes zoomInOut {
    0% {
      transform: scale(0.9);
    }
    50% {
      transform: scale(1.15);
    }
    100% {
      transform: scale(0.9);
    }
  }
`;